export function calculateFlatKpr(price, deposit, annualRate, years) {
  if (![price, deposit, annualRate, years].every(Number.isFinite) || price <= 0 || deposit < 0 || deposit > price || annualRate < 0 || years <= 0) {
    throw new RangeError('Invalid KPR inputs');
  }
  const principal = price - deposit;
  const fees = 17500000;
  return {principal, fees, upfront: deposit + fees, monthly: principal / (years * 12) + principal * annualRate / 100 / 12};
}



// WEBPACK FOOTER //
// ./scripts/page-template/page-builder/simulasi-kpr-calculation.js